module.exports = __webpack_public_path__ + "static/media/Group 1000004064.33de6120.png";